<section class="container">
    <div class="auto-po-modal-container"> 
    <div class="modal-header">
        <h5 class="modal-title pull-left">
            {{title}}
        </h5>
        <a class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
            <span class="fa fa-times-circle fa-2x" aria-hidden="true"></span>
        </a>
    </div>
    <div class="modal-body">
        <div class="modal-body__content">
            <section>
                <form #form="ngForm" class="g-3" [formGroup]="enterEmailForm">
                        <label for="email" class="form-label">Email Id</label>
                        <input type="email" class="form-control form-control" id="email" formControlName="email" [error]="enterEmailForm.get('email')">
                        <form-feedback [formGroup]="enterEmailForm" field="email"></form-feedback>
                </form>
            </section>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-outline-primary mx-2" (click)="onModalClose()">Cancel</button>
        <button class="btn btn-primary text-white mx-2" (click)="emailEntered()" [disabled]="!enterEmailForm.valid">Proceed</button>
    </div>
    </div>
</section>
